export class PaymentMethod {
  bankId: number;
  bankName: string;
  accountNumber: string;
  accountHolder: string;
  amount: number;
}
